const contextLabel = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 'var(--app-font-size-body)',
  fontWeight: 'var(--app-font-weight-medium)',
  letterSpacing: 0,
  '& .MuiButton-startIcon': { margin: 0, color: 'inherit' },
}

export const contextButtonVariants = [
  {
    props: { variant: 'contextConnect' },
    style: {
      ...contextLabel,
      minWidth: 0,
      width: 'fit-content',
      height: 32,
      padding: '0 12px 0 6px',
      gap: '6px',
      borderRadius: 999,
      backgroundColor: 'var(--app-context-connect-btn)',
      color: 'var(--app-context-connect-btn-fg)',
      '&:hover': { backgroundColor: '#0068c1', boxShadow: 'none' },
      '&.Mui-disabled': { opacity: 0.5, color: 'var(--app-context-connect-btn-fg)' },
    },
  },
  {
    props: { variant: 'contextView' },
    style: {
      ...contextLabel,
      minWidth: 0,
      width: 'fit-content',
      height: 32,
      padding: '0 12px 0 6px',
      gap: '8px',
      borderRadius: 999,
      backgroundColor: 'var(--app-context-view-btn)',
      color: '#007ae1',
      '&:hover': { backgroundColor: '#d5dce6', boxShadow: 'none' },
    },
  },
]
